import { memo } from 'react';
import { Link } from 'react-router-dom';
import navigationConfig from 'app/fuse-configs/navigationConfig';

const ALL_ITEMS = navigationConfig.default ?? [];
const NAV_LINKS = ALL_ITEMS.filter(item => !item.children?.length);
const AUTH_LINKS = ALL_ITEMS.filter(item => item.children?.length > 0)
	.flatMap(item => item.children);

function FooterLayout2() {
	return (
		<footer
			style={{
				background: 'linear-gradient(135deg, #0F172A 0%, #1E3A8A 100%)',
				color: 'rgba(255,255,255,0.75)',
				paddingTop: '56px',
				paddingBottom: '32px',
			}}
		>
			<div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 32px' }}>

				{/* ── Top: logo + columnas ── */}
				<div className="flex flex-col md:flex-row gap-40 md:gap-64 mb-48">

					{/* Brand */}
					<div className="shrink-0" style={{ maxWidth: '260px' }}>
						<Link to="/home">
							<img src="assets/images/logos/logo.png" alt="EcoRep" style={{ height: '32px', marginBottom: '16px' }} />
						</Link>
						<p style={{ fontSize: '1.6rem', lineHeight: 1.7, color: 'rgba(255,255,255,0.6)', margin: 0 }}>
							Plataforma de trazabilidad y gestión ambiental para los actores de la cadena REP en Colombia.
						</p>
					</div>

					{/* Nav links */}
					<div>
						<p style={{ fontSize: '1.4rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#38BDF8', marginBottom: '16px' }}>
							Navegación
						</p>
						<div className="flex flex-col gap-10">
							{NAV_LINKS.map(item => (
								<Link
									key={item.id}
									to={item.url}
									style={{ fontSize: '1.6rem', color: 'rgba(255,255,255,0.72)', textDecoration: 'none', transition: 'color 0.15s' }}
									onMouseEnter={e => e.currentTarget.style.color = '#fff'}
									onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.72)'}
								>
									{item.title}
								</Link>
							))}
						</div>
					</div>

					{/* Auth links */}
					<div>
						<p style={{ fontSize: '1.4rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#38BDF8', marginBottom: '16px' }}>
							Plataforma
						</p>
						<div className="flex flex-col gap-10">
							{AUTH_LINKS.map(item => (
								<Link
									key={item.id}
									to={item.url}
									style={{ fontSize: '1.6rem', color: 'rgba(255,255,255,0.72)', textDecoration: 'none', transition: 'color 0.15s' }}
									onMouseEnter={e => e.currentTarget.style.color = '#fff'}
									onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.72)'}
								>
									{item.title}
								</Link>
							))}
						</div>
					</div>

				</div>

				{/* ── Divider ── */}
				<div style={{ height: '1px', background: 'rgba(255,255,255,0.1)', marginBottom: '24px' }} />

				{/* ── Bottom: copyright ── */}
				<div className="flex flex-col sm:flex-row items-center justify-between gap-8">
					<p style={{ fontSize: '1.4rem', color: 'rgba(255,255,255,0.45)', margin: 0 }}>
						© {new Date().getFullYear()} EcoRep. Todos los derechos reservados.
					</p>
					<p style={{ fontSize: '1.4rem', color: 'rgba(255,255,255,0.35)', margin: 0 }}>
						Desarrollado por XM S.A E.S.P.
					</p>
				</div>

			</div>
		</footer>
	);
}

export default memo(FooterLayout2);
